export default __webpack_public_path__ + "static/media/virtual_bg.66113ef2.png";